import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { ObjectTypeIdRegex } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { parseDynamicFilterFamilyId, testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export function useLoadMoreFieldsHandler() {
  const {
    fetchMore,
    data
  } = useContext(SegmentationFiltersInstanceContext);
  const handleLoadMoreFields = useCallback((assetFamily, newOffset, searchQuery) => {
    const fetchRequests = [];
    if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
      const integrationId = parseDynamicFilterFamilyId(DSAssetFamilies.INTEGRATION, assetFamily);
      const integrationFields = data.getIn([DSAssetFamilies.INTEGRATION_PROPERTY, integrationId]);
      if (!integrationFields) {
        fetchRequests.push(fetchMore({
          variables: {
            assetFamily: DSAssetFamilies.INTEGRATION_PROPERTY,
            ids: [integrationId]
          }
        }));
      }
      return Promise.all(fetchRequests);
    }
    if (assetFamily === DSAssetFamilies.SURVEY_MONKEY_QUESTION) {
      const surveyMonkeySurveys = data.get(DSAssetFamilies.SURVEY_MONKEY_SURVEY);
      if (!surveyMonkeySurveys) {
        fetchRequests.push(fetchMore({
          variables: {
            assetFamily: DSAssetFamilies.SURVEY_MONKEY_SURVEY
          }
        }));
      }
    }
    if (ObjectTypeIdRegex.test(assetFamily)) {
      const propertyGroups = data.hasIn([DSAssetFamilies.PROPERTY_GROUP, assetFamily]);
      if (!propertyGroups) {
        fetchRequests.push(fetchMore({
          variables: {
            assetFamily: DSAssetFamilies.PROPERTY_GROUP,
            ids: [assetFamily]
          }
        }));
      }
    }
    if (assetFamily !== DSAssetFamilies.PAGE_VIEW && assetFamily !== DSAssetFamilies.EMAIL_SUBSCRIPTION) {
      fetchRequests.push(fetchMore({
        variables: {
          assetFamily,
          query: searchQuery
        }
      }));
    }
    return Promise.all(fetchRequests);
  }, [fetchMore, data]);
  return handleLoadMoreFields;
}